<div class="horizontal justify-content-center justify-content-sm-between">
  <h4>Custom Fields</h4>

  @if (customFields) {
    <button
      authorizeEnable
      [authorizeRegister]="RegisterPermission.UpdateAsset"
      [authorizeFeature]="PackageFeature.CustomFields"
      type="button"
      class="btn btn-outline mb-2"
      (click)="addCustomFields()"
    >
      <i-lucide name="plus"></i-lucide>
      {{ editTitle }}
    </button>
  }
</div>

@if (!customFields) {
  <app-loading></app-loading>
}

@if (customFields && customFields.length > 0) {
  <ul class="list-group mb-1 pb-2">
    @for (customField of customFields; track customField) {
      <li class="list-group-item pt-3 pe-3">
        <div class="row py-1">
          <div class="col-12 col-sm-4 col-lg-3">
            <strong class="text-break">{{ customField.label }}</strong>
          </div>
          <div class="col-12 col-sm-8 col-lg-9 text-break">
            {{ customField.value }}
          </div>
        </div>
      </li>
    }
  </ul>
}

<app-side-panel #sidePanel></app-side-panel>
